import { useState, useEffect, useCallback } from "react";

const INITIAL_GROUP_BATCH_SIZE = 2;

export { INITIAL_GROUP_BATCH_SIZE };

export function useDrilldownGroups(keys: string[]) {
  const [activatedGroupKeys, setActivatedGroupKeys] = useState<Set<string>>(
    () => new Set(keys.slice(0, INITIAL_GROUP_BATCH_SIZE)),
  );

  useEffect(() => {
    setActivatedGroupKeys((current) => {
      const next = new Set<string>();
      for (const key of keys) {
        if (current.has(key)) next.add(key);
      }
      for (const key of keys.slice(0, INITIAL_GROUP_BATCH_SIZE)) {
        next.add(key);
      }
      // Avoid unnecessary re-render if contents are identical
      if (next.size === current.size && [...next].every((k) => current.has(k))) {
        return current;
      }
      return next;
    });
  }, [keys]);

  const activateGroup = useCallback((groupKey: string) => {
    setActivatedGroupKeys((current) => {
      if (current.has(groupKey)) return current;
      const next = new Set(current);
      next.add(groupKey);
      return next;
    });
  }, []);

  return { activatedGroupKeys, activateGroup } as const;
}
